import { clsx } from 'clsx'

import { MessagingSidebar } from '@tribeplatform/react-components/Messaging'
import { Chat } from '@tribeplatform/react-sdk/types'

import { ErrorBoundary } from '../Error/ErrorBoundry.js'

interface Props {
  chatId: Chat['_id']
  chatOpen?: boolean
}

export const SideBar = ({ chatId, chatOpen }: Props) => {
  return (
    <ErrorBoundary>
      <div
        className={clsx(
          'min-w-64 w-full sm:max-w-xs transition-all duration-300 ease-in-out transition-gpu shrink-0',
          chatOpen ? 'hidden sm:block' : '',
        )}
      >
        <MessagingSidebar chatId={chatId} />
      </div>
    </ErrorBoundary>
  )
}
